import Cookies from 'js-cookie'

export const useCookieFeature = (cookieName: string): boolean => {
  const cookieValue = Cookies.get(cookieName)

  return cookieValue !== undefined
}
